/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { RequireAuth } from '@/app/router/RequireAuth'

const TournamentsPage = lazy(() => import('@/pages/tournaments/Page').then((m) => ({ default: m.TournamentsPage })))
// /tournaments/new now mounts the four-step creation wizard
// (UX brief docs/ux/2026-05-17-tournament-creation-wizard.md). The
// legacy all-fields-at-once Setup page is still used for /:id/edit.
const TournamentCreateWizard = lazy(() =>
  import('@/pages/tournaments/wizard/TournamentCreateWizard').then((m) => ({ default: m.TournamentCreateWizard })),
)
const TournamentEditPage = lazy(() => import('@/pages/tournaments/edit/Page').then((m) => ({ default: m.TournamentEditPage })))
const TournamentDetailPage = lazy(() => import('@/pages/tournaments/detail/Page').then((m) => ({ default: m.TournamentDetailPage })))
// Player team-formation surface (Teams-League self-registration). Auth-gated —
// the backend requires a registered participant; the page self-gates the rest.
const TeamFormationPage = lazy(() => import('@/pages/tournaments/team/Page').then((m) => ({ default: m.TeamFormationPage })))

export function tournamentRoutes() {
  return (
    <>
      <Route
        path="/tournaments/:shortId/team"
        element={
          <RequireAuth>
            <TeamFormationPage />
          </RequireAuth>
        }
      />
      <Route path="/tournaments/:shortId/:slug?" element={<TournamentDetailPage />} />
      <Route path="/tournaments" element={<TournamentsPage />} />
      <Route
        path="/tournaments/new"
        element={
          <RequireAuth requireRole="club_staff">
            <TournamentCreateWizard />
          </RequireAuth>
        }
      />
      <Route
        path="/tournaments/:tournamentId/edit"
        element={
          <RequireAuth requireRole="club_staff">
            <TournamentEditPage />
          </RequireAuth>
        }
      />
    </>
  )
}
